import { selectSmallScreenWarningModal } from '../../store/general/selectors';
import useScreenWidthWarning from '../../hooks/useScreenWidthWarning';
import SmallScreenWarning from '../../containers/SmallScreenWarning';
import ExamRules from '../../containers/ExamRules';
import ExitExam from '../../containers/ExitExam';
import { useSelector } from '../../store/store';
import { Outlet } from 'react-router-dom';
import {
    selectExitExamModal,
    selectExamRulesModal,
} from '../../store/exam/selectors';

export default function Examination() {
    const exitExamModal = useSelector(selectExitExamModal);
    const examRulesModal = useSelector(selectExamRulesModal);
    const smallScreenWarningModal = useSelector(selectSmallScreenWarningModal);
    useScreenWidthWarning(['/examination/coding', '/examination/interview']);

    return (
        <>
            <Outlet />
            {examRulesModal && <ExamRules />}
            {exitExamModal && <ExitExam />}
            {smallScreenWarningModal && <SmallScreenWarning />}
        </>
    );
};
